export const BUTTON_CLICK = 'button_click';
export const LINK_CLICK = 'link_click';
export const MESSAGE_TEXT = 'message_text';
export const BANNER = 'banner';
export const ERROR_BANNER = 'error_banner';
export const CHECKBOX_CLICK = 'checkbox_click';
export const TOOGLE = 'toogle';
